import axios from "axios";
import React, { useEffect, useState } from "react";
import ButtonAll from "../button/Button";
import { LuMessagesSquare } from "react-icons/lu";
import { Link } from "react-router-dom";
import useAuthUser from "../../auth/getUser";
import { HiOutlineChatBubbleLeftRight } from "react-icons/hi2";
import InviteChatModal from "../../common/InviteChatModal";
import { IoClose } from "react-icons/io5";
import { PiBagFill, PiBagSimpleDuotone } from "react-icons/pi";
import { IoLocationOutline } from "react-icons/io5";
import { LuUserCircle } from "react-icons/lu";
const FindEmploye = () => {
  const [searchQuery, setSearchQuery] = useState("");
  const [selectedType, setSelectedType] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 4;
  const { user } = useAuthUser();
  const [showModal, setShowModal] = useState(false);
  const [messageText, setMessageText] = useState("");
  const [users, setUsers] = useState([]);

  useEffect(() => {
    const fetchUsers = async () => {
      try {
        const result = await axios.get(
          `${process.env.REACT_APP_BASE_API}/userdata`
        );
        setUsers(result.data); // Assuming result.data is the array of user data
      } catch (error) {
        console.error("Error fetching user data:", error);
      }
    };

    fetchUsers();
  }, []);

  // Filter users with role 'employer'
  const employers = users?.filter((user) => user.role === "job-seeker");

  // Filter based on search query and selected type
  const filteredEmployees =
    employers?.filter((em) => {
      const matchesSearch =
        em.name?.toLowerCase().includes(searchQuery.toLowerCase()) ||
        "" ||
        em.role?.toLowerCase().includes(searchQuery.toLowerCase()) ||
        "" ||
        em.location?.toLowerCase().includes(searchQuery.toLowerCase()) ||
        "";
      const matchesType = selectedType ? em.employment === selectedType : true;
      return matchesSearch && matchesType;
    }) || [];

  // Pagination logic
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentEmployees =
    filteredEmployees?.slice(indexOfFirstItem, indexOfLastItem) || [];
  const totalPages = Math.ceil(filteredEmployees?.length / itemsPerPage);

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  const [selectedId, setSelectedId] = useState("");
  const sendMessage = async (selectedUserId) => {
    if (messageText.trim() !== "" && user && selectedUserId) {
      const newMessage = {
        sender: user?._id,
        receiver: selectedUserId,
        text: messageText,
      };

      try {
        const response = await axios.post(
          `${process.env.REACT_APP_BASE_API}/message`,
          newMessage
        );
        setMessageText("");
      } catch (error) {
        console.error("Error sending message:", error);
      }
    }
  };

  return (
    <div className="mt-10 max-w-4xl mx-auto">
      <p className=" text-xs pb-5">
        Are you seeking someone to join your team? Find them here, invite them,
        and start building your team of skilled talent from the Philippines.
      </p>
      <div className="mb-4 flex justify-center">
        <input
          type="text"
          placeholder="Search"
          value={searchQuery}
          onChange={(e) => setSearchQuery(e.target.value)}
          className="border border-base-300 p-2 rounded-2xl mr-2"
        />
        <select
          value={selectedType}
          onChange={(e) => setSelectedType(e.target.value)}
          className="border border-base-300 p-2 rounded-2xl"
        >
          <option value="">Select type</option>
          <option value="full-time">Full-time</option>
          <option value="part-time">Part-time</option>
        </select>
      </div>
      {showModal && (
        <div className="fixed inset-0 bg-gray-600 bg-opacity-50 flex justify-center items-center overflow-y-auto">
          <div className="bg-white rounded-lg shadow-lg p-3 w-full max-w-xl">
            <div className="flex items-center justify-between py-2 px-4 rounded-lg bg-[#edf7f4]">
              <p>Invite To A job</p>
              <IoClose
                onClick={() => setShowModal(false)}
                size={30}
                className="text-gray-400 cursor-pointer"
              />
            </div>
            <div className="flex items-start gap-5 py-5">
              <div>
                <LuUserCircle size={50} />
              </div>
              <div className="flex flex-col items-start gap-3">
                <div>
                  <h1 className="text-xl font-semibold">
                    First Middle Last Name
                  </h1>
                </div>
                <div className="space-y-1">
                  <div className="flex items-center gap-3">
                    <PiBagSimpleDuotone size={25} />
                    <p className="text-sm">Talent Acquisition Specialist</p>
                  </div>
                  <div className="flex items-center gap-3">
                    <IoLocationOutline size={30} />
                    <p className="text-sm">Jakarta, Indonesia.</p>
                  </div>
                </div>
              </div>
            </div>
            <div>
              <p className="text-md font-[450]">Message</p>
              <textarea
                onChange={(e) => setMessageText(e.target.value)}
                value={messageText}
                className="h-40 rounded-lg border w-full outline-0 border-gray-200 p-2"
                placeholder="Enter your name"
              />
              <button
                className={`${
                  !messageText ? "opacity-50" : ""
                } w-full px-3 py-2 rounded-lg text-white !bg-[#20A3BA]`}
                onClick={() => sendMessage(selectedId)}
              >
                Send Invitation
              </button>
            </div>
          </div>
        </div>
      )}
      <div className="grid lg:grid-cols-2 textw">
        {currentEmployees?.length > 0 ? (
          currentEmployees?.map((em) => (
            <>
              {em?.isVisable && (
                <div
                  key={em._id}
                  className="border border-base-300 shadow-md rounded-md p-4 m-2"
                >
                  <div className="flex gap-3 items-center mb-2">
                    <img
                      className="w-20 bgw h-20 rounded-full"
                      src={em.image || "default-image.jpg"}
                      alt={em.name}
                    />
                    <div>
                      <h1 className="text-xl font-bold">{em.name}</h1>
                      <h1>{em.role}</h1>
                      <h1>{em.location}</h1>
                    </div>
                  </div>

                  <div className="mt-5 pb-6 flex justify-between">
                    <div>
                      <h1>Preferred Job Type</h1>
                      <h2 className="text-xl font-bold">{em.employment}</h2>
                    </div>
                    <div>
                      <h2>Skills</h2>
                      <h1 className="text-bold flex flex-col">{em.skill}</h1>
                    </div>
                  </div>
                  <div className="flex gap-2 items-center">
                    <Link to={`/profile/${em?._id}`}>
                      <ButtonAll>Know More</ButtonAll>
                    </Link>
                    {/* {user?.role === "admin" ||
                  (user?.role === "employeer" && ( */}
                    <LuMessagesSquare
                      onClick={() => {
                        setSelectedId(em?._id);
                        setShowModal(true);
                      }}
                      className="text-[#20A3BA] text-2xl cursor-pointer"
                    />
                    {/* ))} */}
                  </div>
                </div>
              )}
            </>
          ))
        ) : (
          <div className="col-span-2  w-full flex justify-center items-center py-6 text-center">
            <img src="/no-employy-img.svg" alt="" className=" w-2/4" />
          </div>
        )}
      </div>

      <div className="flex justify-center my-4">
        <button
          onClick={() => handlePageChange(currentPage - 1)}
          disabled={currentPage === 1}
          className="btn btn-outline mx-1"
        >
          Previous
        </button>
        {Array.from({ length: totalPages }, (_, index) => (
          <button
            key={index + 1}
            onClick={() => handlePageChange(index + 1)}
            className={`btn btn-outline mx-1 ${
              currentPage === index + 1 ? "btn-active" : ""
            }`}
          >
            {index + 1}
          </button>
        ))}
        <button
          onClick={() => handlePageChange(currentPage + 1)}
          disabled={currentPage === totalPages}
          className="btn btn-outline mx-1"
        >
          Next
        </button>
      </div>
    </div>
  );
};

export default FindEmploye;
